import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LeadSourcesComponent } from './masters/lead-sources/lead-sources.component';
import { TeamsIndexComponent } from './masters/teams-index/teams-index.component';
import { UsersComponent } from './masters/users/users.component';
import { LeadStatusComponent } from './masters/lead-status/lead-status.component';
import { LeadSubStatusComponent } from './masters/lead-sub-status/lead-sub-status.component';
import { LeadMediumComponent } from './masters/lead-medium/lead-medium.component';
import { CommunicationSetupComponent } from './masters/communication-setup/communication-setup.component';
import { LeadImportComponent } from './masters/lead-import/lead-import.component';
import { CoursesComponent } from './masters/courses/courses.component';
import { LeadCampaignComponent } from './masters/lead-campign/lead-campaign.component';
import { LeadsComponent } from './leads/leads.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TestComponent } from './masters/test/test.component';
import { LeadUploadComponent } from './masters/lead-upload/lead-upload.component';
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { UseractivityComponent } from './useractivity/useractivity.component';
import { RawListComponent } from './raw-list/raw-list.component';
import { WhatsappTemplateComponent } from './communication-templates/whatsapp-template/whatsapp-template.component';
import { SmsTemplateComponent } from './communication-templates/sms-template/sms-template.component';
import { EmailTemplateComponent } from './communication-templates/email-template/email-template.component';
import { LeadDistributionComponent } from './masters/lead-distribution/lead-distribution.component';
import { LeadChannelComponent } from './masters/lead-channel/lead-channel.component';
import { SourceWiseLeadStatusComponent } from './source-wise-lead-status/source-wise-lead-status.component';
import { LeadConditionsComponent } from './lead-conditions/lead-conditions.component';
import { MyUploadsComponent } from './my-uploads/my-uploads.component';
import { UpcomingFollowUpsComponent } from './upcoming-follow-ups/upcoming-follow-ups.component';
import { FailedFollowUpsComponent } from './failed-follow-ups/failed-follow-ups.component';
import { UserWiseActivityComponent } from './reports/user-wise-activity/user-wise-activity.component';
import { CounsellorLeadStatusComponent } from './reports/counsellor-lead-status/counsellor-lead-status.component';
import { StatusWiseAverageTimeComponent } from './reports/status-wise-average-time/status-wise-average-time.component';
import { RestoreComponent } from './restore/restore.component';
import { BackupComponent } from './backup/backup.component';
import { BulkReassignLeadsComponent } from './bulk-reassign-leads/bulk-reassign-leads.component';
import { AuthGuard } from './utility/Auth-Guard';
import { CounsellorPerformanceComponent } from './reports/counsellor-performance/counsellor-performance.component';
import { StudentCounsellorWiseFollowupsComponent } from './reports/student-counsellor-wise-followups/student-counsellor-wise-followups.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { LeadsJourneyComponent } from './reports/leads-journey/leads-journey.component';
import { AccessPermissionComponent } from './access-permission/access-permission.component';
import { LeadAgeingReportComponent } from './reports/lead-ageing-report/lead-ageing-report.component';
import { SystemStatusDashboardComponent } from './reports/system-status-dashboard/system-status-dashboard.component';

const routes: Routes = [
  { path: 'unauthorized', component: UnauthorizedComponent },

  { path: 'lead-sub-status', component: LeadSubStatusComponent, canActivate: [AuthGuard] },
  { path: 'lead-channel', component: LeadChannelComponent, canActivate: [AuthGuard] },
  { path: 'lead-status', component: LeadStatusComponent, canActivate: [AuthGuard] },
  { path: 'lead-source', component: LeadSourcesComponent, canActivate: [AuthGuard] },
  { path: 'users', component: UsersComponent, canActivate: [AuthGuard] },
  { path: 'lead-conditions', component: LeadConditionsComponent, canActivate: [AuthGuard] },
  { path: 'lead-campign', component: LeadCampaignComponent, canActivate: [AuthGuard] },
  { path: 'lead-medium', component: LeadMediumComponent, canActivate: [AuthGuard] },
  { path: 'communication-setup', component: CommunicationSetupComponent, canActivate: [AuthGuard] },
  { path: 'lead-distribution', component: LeadDistributionComponent, canActivate: [AuthGuard] },
  { path: 'email-template', component: EmailTemplateComponent, canActivate: [AuthGuard] },
  { path: 'whatsapp-template', component: WhatsappTemplateComponent, canActivate: [AuthGuard] },
  { path: 'sms-template', component: SmsTemplateComponent, canActivate: [AuthGuard] },
  { path: 'courses', component: CoursesComponent, canActivate: [AuthGuard] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'leads', component: LeadsComponent, canActivate: [AuthGuard] },
  { path: 'upcoming-follow-ups', component: UpcomingFollowUpsComponent, canActivate: [AuthGuard] },
  { path: 'raw-list', component: RawListComponent, canActivate: [AuthGuard] },
  { path: 'failed-follow-ups', component: FailedFollowUpsComponent, canActivate: [AuthGuard] },
  { path: 'bulk-reassign-leads', component: BulkReassignLeadsComponent, canActivate: [AuthGuard] },
  { path: 'lead-upload', component: LeadUploadComponent, canActivate: [AuthGuard] },
  { path: 'user-dashboard', component: UserDashboardComponent, canActivate: [AuthGuard] },
  { path: 'user-activity', component: UseractivityComponent, canActivate: [AuthGuard] },
  { path: 'my-uploads', component: MyUploadsComponent, canActivate: [AuthGuard] },
  { path: 'source-wise-lead-status', component: SourceWiseLeadStatusComponent, canActivate: [AuthGuard] },
  { path: 'status-wise-average-time', component: StatusWiseAverageTimeComponent, canActivate: [AuthGuard] },
  { path: 'counsellor-lead-status', component: CounsellorLeadStatusComponent, canActivate: [AuthGuard] },
  { path: 'user-wise-activity', component: UserWiseActivityComponent, canActivate: [AuthGuard] },
  { path: 'backup', component: BackupComponent, canActivate: [AuthGuard] },
  { path: 'restore', component: RestoreComponent, canActivate: [AuthGuard] },
  { path: 'counsellor-performance', component: CounsellorPerformanceComponent, canActivate: [AuthGuard] },
  { path: 'student-wise-followups', component: StudentCounsellorWiseFollowupsComponent, canActivate: [AuthGuard] },
  { path: 'leads-journey', component: LeadsJourneyComponent, canActivate: [AuthGuard] },
  { path: 'access-permission', component: AccessPermissionComponent, canActivate: [AuthGuard] },
  { path: 'lead-ageing', component: LeadAgeingReportComponent, canActivate: [AuthGuard] },
  { path: 'system-status-report', component:SystemStatusDashboardComponent,canActivate:[AuthGuard]},
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  { path: '**', redirectTo: '/unauthorized' }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
